import {IComponentController, IComponentOptions} from "angular";
import {BranchesService} from "../../../branches_service/service/branches-service";
import {ToastNotificationService} from "../../../utils/ToastNotificationService";
import {BranchesServiceName, BrandServiceName, ToastNotificationServiceName} from "../../../utils/names/serviceNames";
import {BrandService} from "../../../brand_service/service/BrandService";
import './branches-picker-component.scss';

export class BranchesPickerComponent implements IComponentController {

    private selectedBranchesNames: String[];

    public static instance: IComponentOptions = {
        template: require('./branches-picker.component.html'),
        controller: [
            BranchesServiceName,
            BrandServiceName,
            ToastNotificationServiceName,
            BranchesPickerComponent
        ],
        bindings: {
            selectedBranchesNames: '='
        }
    };

    constructor(private branchesService: BranchesService,
                private brandService: BrandService,
                private toastNotificationService: ToastNotificationService) {
    }

    branchesChanged = (selectedBranchesNames: String[]) => {
        this.selectedBranchesNames = selectedBranchesNames;
    };

}